import React from 'react'
import { Link as GLink } from 'gatsby'
import { Link, Heading } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'

function isContainsHtmlTags(input) {
  const htmlTagRegex = /<\/?[a-z][\s\S]*>/i;
  return htmlTagRegex.test(input);
}

const CardBodyTitle = ({ variant, title, slug, link }) => {
  slug = variant[0] === 'cards.search' ? `/${slug}` : slug;
  const linkProps = link
    ? {
        as: 'a',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : {
        as: GLink,
        to: slug
      }
  return (
    <Heading {...linkProps} sx={{ variant: rv(variant, 'title') }}>
      {!isContainsHtmlTags(title) ? (
        <span style={variant[0] === 'cards.search' ? { color: '#667eea' } : {}}>
          {title}
        </span>
      ) : (
        <span
          style={variant[0] === 'cards.search' ? { color: '#667eea' } : {}}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
    </Heading>
  )
}

export default CardBodyTitle
